<template>
    <div>
        <h2 class="d-inline mb-0" v-if="showName">
            <a v-if="employeelink == 1" :href="'/employees/' + employee.id" class="text-underline-hover">{{
                employee.lastname
                }}, {{ employee.forename }}</a>
            <span v-if="employeelink != 1">{{ employee.lastname }}, {{ employee.forename }}</span>
        </h2>
        <div class="d-inline" v-else id="employeeParent" ref="">
            <input type="text" ref="employeeInput" id="employeename" @blur="showName = true" />
        </div>
        &nbsp;
        <span class="material-symbols-outlined cursor-pointer" @click="showEmployeeInput" v-tooltip
            :title="$trans.get('__JSON__.Change Employee')">
            repeat
        </span>
        <span class="material-symbols-outlined cursor-pointer mx-2" @click="toggleDropdown()" v-tooltip
            :title="$trans.get('__JSON__.Change Employee')">
            person_search
        </span>
        <div v-show="dropdownVisible && teams.length > 0" class="user-change-list">
            <select ref="employeeSelect" class="d-inline form-select" v-model="choosen_employee_id"
                @blur="handleBlur" @change="handleEmployeeSelect" size="10">
                <optgroup v-for="team in teams" :label="team.name" :key="team.id">
                    <option v-for="employee in sortedEmployees(team)" :value="employee.id" :key="employee.id">
                        {{ employee.lastname }}, {{ employee.forename }}
                    </option>
                </optgroup>
            </select>
        </div>
        <employee-info :employee_id="employee.id" v-tooltip :title="$trans.get('__JSON__.Employee information')" />
        <span v-if="employee.employer && employee.employer.shortname != 'HAL'" class="material-symbols-outlined ms-2"
            v-tooltip :title="employee.employer.name"> work_history
        </span>
    </div>
</template>

<script>
import { ref } from "vue";
import getEmployees from "../composables/getEmployees";

export default {
    name: "ChangeEmployeeInline",
    props: {
        employeelink: String,
        employee: null,
        lead_employee_id: null
    },
    data() {
        return {
            employee_id: this.employee.id,
            choosen_employee_id: "",
            teams: [],
            dropdownVisible: false,
        }
    },
    methods: {        
        toggleDropdown() {
            $(".tooltip").css('display', 'none');
            this.dropdownVisible = !this.dropdownVisible;
            if (this.dropdownVisible) {
                this.$nextTick(() => {
                    this.$refs.employeeSelect.focus();
                });
            }
        },
        handleBlur() {
            $(".tooltip").css('display', 'none');
            setTimeout(() => {
                this.dropdownVisible = false;  
            }, 100);
        },
        handleEsc(event) {
            $(".tooltip").css('display', 'none');
            if (event.key === 'Escape') {
                this.dropdownVisible = false;  
                this.showName = true;
            }
        },
        showEmployeeInput: function () {
            $(".tooltip").css('display', 'none');
            this.showName = false;

            this.$nextTick(() => {
                this.$refs.employeeInput.focus();
            });

            const { employees, employees_error, loadEmployees } = getEmployees();
            loadEmployees().then(response => {

                const acemployees = ref([]);
                employees.value.forEach((item) => {
                    if (item.inactive == false) {
                        const employee = {
                            label: item.lastname + ", " + item.forename,
                            value: item.id,
                        };
                        acemployees.value.push(employee);
                    }
                });

                $('#employeename').autocomplete({
                    source: acemployees.value,
                    appendTo: '#employeeParent'
                });

                var self = this;

                $('#employeename').on("autocompleteselect", function (event, ui) {
                    $(this).prop('disabled', true);
                    $(this).val(ui.item.label);
                    self.choosen_employee_id = ui.item.value;

                    self.handleEmployeeSelect();
                });                
            });
        },
        handleEmployeeSelect() {            
            document.location.href = document.location.href
                .replace('employees/' + this.employee_id, 'employees/' + this.choosen_employee_id)
                .replace('=' + this.employee_id, '=' + this.choosen_employee_id);
            return false;
        },
        sortedEmployees(team) {
            return team.employees.sort((a, b) => a.lastname.localeCompare(b.lastname)).filter( (employee) => employee.inactive == false);
        },
        fetchTeamleads() {
            axios
                .get("/api/employees/" + this.lead_employee_id + "/shiftleads", {})
                .then((resp) => {
                    this.teams = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    mounted() {
        document.addEventListener('keydown', this.handleEsc);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleEsc);
    },
    computed: {
        autocompleteemployees() {
            var acemployees = [];
            if (this.employees != null) {
                this.employees.forEach((item) => {
                    if (item.inactive == false) {
                        const employee = {
                            label: item.lastname + ", " + item.forename,
                            value: item.id,
                        };
                        acemployees.push(employee);
                    }
                });
            }
            return acemployees;
        },
    },
    setup(props) {
        const showName = ref(true);

        return { showName };
    },
    created() {
        this.fetchTeamleads();        
    },
    watch: {
        employee: {
            handler(newValue) {
                if (newValue && newValue.id) {
                    this.employee_id = newValue.id;
                }
            },
            immediate: true,
        },
    },
}

</script>

<style lang="scss">

.user-change-list {
    position: absolute;
    z-index: 1000;
}

</style>
